var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6007 25.0724L22.9542 19.4258C22.6993 19.171 22.3539 19.0294 21.9914 19.0294C21.6164 19.0294 21.4007 18.5933 21.6079 18.2807C22.8428 16.4177 23.5602 14.1842 23.5602 11.7801C23.5602 5.27273 18.2875 0 11.7801 0C5.27273 0 0 5.27273 0 11.7801C0 18.2875 5.27273 23.5602 11.7801 23.5602C14.1842 23.5602 16.4177 22.8428 18.2807 21.6079C18.5933 21.4007 19.0294 21.6164 19.0294 21.9914C19.0294 22.3539 19.171 22.6993 19.4258 22.9542L25.0724 28.6007C25.6047 29.1331 26.4656 29.1331 26.9923 28.6007L28.5951 26.998C29.1274 26.4656 29.1274 25.6047 28.6007 25.0724ZM11.7801 19.0294C7.776 19.0294 4.53081 15.7899 4.53081 11.7801C4.53081 7.776 7.77033 4.53081 11.7801 4.53081C15.7842 4.53081 19.0294 7.77034 19.0294 11.7801C19.0294 15.7842 15.7899 19.0294 11.7801 19.0294Z",
    fill: "#ACDAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.cc9574a20223f2c0a217b70bc672cfa7.svg";
export { ForwardRef as ReactComponent };